<template>
  <div class="register_box">
    <div class="register_centent">
      <div class="register_box_title">
        {{ $t("account_management.Change_Password.ChangePassword") }}
      </div>
      <div class="TGA_BOX" v-for="(item, index) in data">
        <div class="TGA_INPUT_BOX" :class="item.active ? 'TGA_BR' : ''">
          <div class="TGA_TEXT">
            <span class="must">*</span>
            {{ item.title }}
          </div>
          <input
            :class="item.type == 'number' ? 'TGA_CODE_ACTIVE' : ''"
            v-model="item.input"
            @input="changeCount(item.input, index)"
            class="TGA_INPUT"
            :type="item.type"
          />
          <!-- <div v-if="item.type == 'number'" class="TGA_CODE">获取验证码</div> -->
          <div class="TGA_INIT_Password" v-if="item.init != ''">
            <div class="TGA_INIT TGA_INIT_Password_input">{{ item.init }}</div>
          </div>

          <div class="TGA_INPUT_INIT" v-if="item.active">
            <img src="@/img/mistake.png" alt="" />
            <span>{{ item.Text }}</span>
          </div>
        </div>
      </div>
      <div class="TGA_BTN" @click="submit" :class="BTN ? 'TGA_BTN_ACTIVE' : ''">
        {{ $t("account_management.Change_Password.alter") }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      data: [
        {
          title: this.$t("account_management.Change_Password.originalpsd"),
          input: "",
          Text: this.$t(
            "account_management.Change_Password.please_originalpsd"
          ),
          active: false,
          type: "password",
          init: "",
        },

        {
          title: this.$t("account_management.Change_Password.psd"),
          input: "",
          Text: this.$t("account_management.Change_Password.empty_psd"),
          active: false,
          type: "password",
          init: this.$t("account_management.Change_Password.psd_init"),
        },
        {
          title: this.$t("account_management.Change_Password.psd1"),
          input: "",
          Text: this.$t("account_management.Change_Password.no_psd1"),
          active: false,
          type: "password",
          init: "",
        },
      ],

      BTN: false,
    };
  },
  beforeCreate() {},
  methods: {
    ...mapActions("user", ["tipMessage", "EditPass"]),
    changeCount(text, i) {
      var ps =
        /^[\w\!\?\,\<\>\.\@\#\$\%\^\&\*\(\)\{\}\[\]\-\~\+\=\/\\\:\;]{8,15}$/;
      if (text == "") {
        this.data[i].active = true;
        switch (i) {
          case 0:
            this.data[i].Text = this.$t(
              "account_management.Change_Password.empty_originalpsd"
            );
            break;
          case 1:
            this.data[i].Text = this.$t(
              "account_management.Change_Password.empty_psd"
            );
            break;
          case 2:
            this.data[i].Text = this.$t(
              "account_management.Change_Password.empty_psd"
            );
            break;
        }
      } else {
        if (i == 0 && !ps.test(text)) {
          this.data[i].Text = this.$t(
            "account_management.Change_Password.psd_init"
          );
          this.data[i].active = true;
        } else if (i == 1 && !ps.test(text)) {
          this.data[i].Text = this.$t(
            "account_management.Change_Password.psd_init"
          );
          this.data[i].active = true;
          if (this.data[2].input != "") {
            this.changeCount(this.data[2].input, 2);
          }
        } else if (i == 2 && this.data[1].input != text) {
          this.data[i].Text = this.$t(
            "account_management.Change_Password.no_psd1"
          );
          this.data[i].active = true;
        } else if (i == 2 && !ps.test(text)) {
          this.data[i].Text = this.$t(
            "account_management.Change_Password.psd_init"
          );
          this.data[i].active = true;
        } else {
          this.data[i].active = false;
          if (i == 1 && this.data[2].input != "") {
            this.changeCount(this.data[2].input, 2);
          }
        }
      }
    },

    // 修改成功后
    async submit() {
      if (!this.BTN) {
        return;
      }
      if (this.data[2].input != this.data[1].input) {
        this.data[2].Text = $t("account_management.Change_Password.no_psd1");
        this.data[2].active = true;
        return;
      }
      var obj = {
        oldPassword: this.$md5(this.data[0].input),
        newPassword: this.$md5(this.data[1].input),
        type: 0,
      };

      const res = await this.EditPass({
        $axios: this.$axios,
        ...obj,
      });
      if (res.code == 200) {
        this.tipMessage({
          context: this.$t("account_management.Change_Password.successfully"),
        });
        for (var i = 0; i < this.data.length; i++) {
          this.data[i].input = "";
        }
      } else {
        switch (res.code) {
          case 10014:
            this.data[0].active = true;
            this.data[0].Text = this.$t(`code[${res.code}]`);
            break;
          case -103:
          case -104:
          case -113:
            this.data[1].active = true;
            this.data[1].Text = this.$t(`code[${res.code}]`);
            break;
          default:
            this.$message.error(this.$t("code.info"));
        }
      }
    },
  },

  computed: {},
  watch: {
    data: {
      handler: function (newValue, oldValue) {
        for (var i = 0; i < newValue.length; i++) {
          if (newValue[i].input == "") {
            this.BTN = false;
            return;
          }
        }
        this.BTN = true;
      },
      deep: true,
    },
  },
};
</script>
<style scoped="">
.register_box {
  width: 100%;
  height: 100%;
}
.register_centent {
  padding: 0 0 90px 0;
  /* margin: 90px  auto 0; */
  /* width: 1160px; */
  /* height: 645px; */
  background-color: #ffffff;
  box-shadow: 0px 2px 30px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  box-sizing: border-box;
  padding-top: 65px;
}
.register_box_title {
  margin-bottom: 51px;
  color: #282828;
  font-size: 22px;
  text-align: center;
  font-weight: bold;
}
.TGA_INIT_Password {
  margin-top: 11px;
  /* height: 30px; */
  left: 0;
  top: 0;
  position: relative;
  margin-bottom: 25px;
}
.TGA_INIT_Password_input {
  margin-top: 0;
  position: absolute;
  width: 600px;
  left: 0;
  top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/account_management/Change_Password.vue